<ng-content></ng-content>
<div class="stripe" [style.border-right-color]="stripe">&nbsp;</div>
